export type ArtworkData = {
  id: number;
  targetName: string;
  artworkName?: string;
  file: string;
  audio: string;
  basePath: string;
};

export const artworkData: ArtworkData[] = [
  {
    id: 0,
    targetName: "cube_A",
    artworkName: "car",
    file: "/artworks/Car_Scene_A_Baked_V004.gltf",
    audio: "/fedex-song.mp3",
    basePath: "/artworks/car/",
  },
  {
    id: 1,
    targetName: "cube_B",
    artworkName: "test-cube",
    file: "/artworks/cube.glb",
    audio: "/fedex-song.mp3",
    basePath: "/artworks/home/",
  },
  {
    id: 2,
    targetName: "cube_C",
    file: "/artworks/plane_A.glb",
    audio: "/fedex-song.mp3",
    basePath: "/artworks/landlord/",
  },
  {
    id: 3,
    targetName: "cube_D",
    file: "/artworks/plane_B.glb",
    audio: "/fedex-song.mp3",
    basePath: "/artworks/test-cube",
  },
  {
    id: 4,
    targetName: "cube_E",
    file: "/artworks/plane_B.glb",
    audio: "/fedex-song.mp3",
    basePath: "/artworks/test-cube",
  },
];
